var formatType;
(function (formatType) {
    formatType[formatType["ddmmyyyy"] = 0] = "ddmmyyyy";
})(formatType || (formatType = {}));
function formatDate(date, format, delimeter = "/") {
    if (format === formatType.ddmmyyyy) {
        const result = date.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
        return result.replaceAll("/", delimeter);
    }
    return date.toDateString();
}

export { formatDate, formatType };
//# sourceMappingURL=formatDate.js.map
